import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import makeStyles from "@mui/styles/makeStyles";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },

  itemText: {
    fontSize: "1.4rem",
    lineHeight: "1.8rem",
    textTransform: "none",
  },
}));

const NavigationMenuHeading = props => {
  const { icon, primary, children, expand = false } = props;
  const [open, setOpen] = React.useState(expand);
  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <li>
      <ListItem onClick={handleClick} button>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText
          classes={{ root: classes.itemText }}
          disableTypography={true}
          primary={primary}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List className={classes.nested} component="ul" disablePadding>
          {children}
        </List>
      </Collapse>
    </li>
  );
};

export default NavigationMenuHeading;
